/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, CardContent, Typography, Button, Skeleton, useMediaQuery, useTheme as MuiTheme } from "@mui/material";
import { useTheme } from "../../style/theme";
import Image from "../Image";
import { useUser } from "../../hooks/Authorize";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const cardData = [
  {
    title: "Clikkle Ads",
    organization: "Rakesh Corp",
    icon: "ads/logo/2023/ads.png",
    route: "https://ads.clikkle.com",
  },
  {
    title: "Clikkle Campaigns",
    type: "campaigns",
    organization: "Rakesh Corp",
    icon: "campaigns/logo/2025/clikkle%20campaigns.png",
    route: "https://campaigns.clikkle.com",
  },
  {
    title: "Clikkle CRM",
    organization: "Rakesh Corp",
    icon: "crm/2025/clikkle%20crm.png",
    route: "https://crm.clikkle.com",
  },
  {
    title: "Clikkle Host",
    organization: "Rakesh Corp",
    icon: "host/logo/2023/host.png",
    route: "https://host.clikkle.com",
  },
  {
    title: "Clikkle HR",
    type: "hr",
    organization: "Rakesh Corp",
    icon: "hr/logo/2025/clikkle%20hr.png",
    route: "https://hr.clikkle.com",
  },
  {
    title: "Clikkle Launch",
    organization: "Rakesh Corp",
    icon: "launch/logo/2023/launch.png",
    route: "https://launch.clikkle.com",
  },
  {
    title: "Clikkle Mail",
    organization: "Rakesh Corp",
    icon: "cmail/logo/2023/cmail.png",
    route: "https://mail.clikkle.com",
  },
  {
    title: "Clikkle Pitch",
    organization: "Rakesh Corp",
    icon: "pitch/logo/2023/pitch.png",
    route: "https://pitch.clikkle.com",
  },
  {
    name: "Worksuite",
    title: "Clikkle Worksuite",
    type: "worksuite",
    organization: "Rakesh Corp",
    icon: "worksuite/2025/clikkle%20worksuite.png",
    route: "https://worksuite.clikkle.com",
  },
  {
    name: "Chat",
    title: "Clikkle Chat",
    type: "chat",
    organization: "Rakesh Corp",
    icon: "chat/logo/2025/clikkle%20chat.png",
    route: "https://chat.clikkle.com",
  },
  {
    name: "Projects",
    title: "Clikkle Projects",
    type: "project",
    organization: "Rakesh Corp",
    icon: "projects/logo/2025/clikkle%20projects.png",
    route: "https://projects.clikkle.com",
  },
  {
    name: "Calendar",
    title: "Clikkle Calendar",
    organization: "Rakesh Corp",
    icon: "calendar/logo/2025/Clikkle%20Calendar.png",
    route: "https://calendar.clikkle.com",
  },
  {
    name: "Crew",
    title: "Clikkle Crew",
    organization: "Rakesh Corp",
    icon: "crew/logo/2025/Clikkle%20Crew.png",
    route: "https://crew.clikkle.com",
  },
  {
    name: "Creator AI",
    title: "Clikkle Creator AI",
    organization: "Rakesh Corp",
    icon: "creator/logo/2025/Clikkle%20Creator.png",
    route: "https://creator.clikkle.com",
  },
  {
    title: "Clikkle News",
    organization: "Rakesh Corp",
    icon: "news/logo/2023/news.png",
    route: "https://news.clikkle.com",
  },
  {
    title: "Clikkle Promo",
    organization: "Rakesh Corp",
    icon: "promo/logo/2025/Clikkle%20Promo.png",
    route: "https://promo.clikkle.com",
  },
  {
    title: "Clikkle SMS",
    organization: "Rakesh Corp",
    icon: "sms/logo/2023/sms.png",
    route: "https://sms.clikkle.com",
  },
  {
    title: "Clikkle Social",
    organization: "Rakesh Corp",
    icon: "social/logo/2023/social.png",
    route: "https://social.clikkle.com",
  },
  {
    title: "Clikkle Swiprr",
    organization: "Rakesh Corp",
    icon: "swiprr/logo/2023/swiprr.png",
    route: "https://swiprr.clikkle.com",
  },
  {
    title: "Clikkle Tax",
    organization: "Rakesh Corp",
    icon: "tax/logo/2023/tax.png",
    route: "https://tax.clikkle.com",
  },
];

const Unused = () => {
  const [loading, setLoading] = useState(true);
  const [organizations, setOrganizations] = useState([]);
  const platformUser = useUser();
  const navigate = useNavigate();

  const getOrganizations = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `/store/organization?userId=${platformUser?._id}`
      );
      const fetchedOrganizations = response?.data?.data;
      setOrganizations(fetchedOrganizations);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch organizations:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    getOrganizations();
  }, []);

  const { mode } = useTheme();
  const theme = MuiTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        paddingBottom: { xs: "60px", sm: "20px" },
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
          },
          gap: 2,
          mt: 2,
          mx: 3,
        }}
      >
        {loading ? (
          <>
            <Box sx={{ gridColumn: "1 / -1", mb: 2, textAlign: "center" }}>
              <Typography variant="h6" color="textSecondary">
                Loading Unused Services...
              </Typography>
            </Box>
            {Array.from({ length: 9 }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  borderRadius: "12px",
                  p: 2,
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                  border: `1px solid ${mode === "light" ? "#e5e7eb" : "#2E2E2E"
                    }`,
                  width: "100%",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Skeleton
                    variant="rectangular"
                    width={isMobile ? 50 : 80}
                    height={isMobile ? 50 : 80}
                    sx={{ borderRadius: 2, mr: 2 }}
                    animation="pulse"
                  />
                  <Box sx={{ flexGrow: 1 }}>
                    <Skeleton
                      variant="text"
                      width="70%"
                      height={30}
                      animation="pulse"
                    />
                    <Skeleton
                      variant="text"
                      width="50%"
                      height={20}
                      animation="pulse"
                    />
                  </Box>
                </Box>
                <Box sx={{ mt: 2 }}>
                  <Skeleton
                    variant="rectangular"
                    height={10}
                    width="100%"
                    sx={{ borderRadius: 1 }}
                    animation="pulse"
                  />
                  <Skeleton
                    variant="text"
                    width="30%"
                    height={15}
                    sx={{ mt: 1 }}
                    animation="pulse"
                  />
                </Box>
              </Box>
            ))}
          </>
        ) : cardData.length > 0 ? (
          cardData.map((service, index) => {
            if (service.type && organizations.some(org => org.type === service.type)) {
              return null;
            }

            return (
              <Box
                key={index}
                sx={{
                  backgroundColor: mode === "light" ? "#fff" : "#141414",
                  border: `1px solid ${mode === "light" ? "#DFDFDF" : "#2E2E2E"
                    }`,
                  borderRadius: "12px",
                  width: "100%",
                  px: 2,
                  py: 0.2,
                }}
              >
                <CardContent sx={{ p: 0 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 2,
                      flexDirection: "row",
                      flexWrap: "nowrap",
                    }}
                  >
                    {/* Icon Box */}
                    <Box
                      sx={{
                        width: { xs: 65, sm: 130 },
                        height: { xs: 65, sm: 100 },
                        borderRadius: "8px",
                        border: `1px solid ${mode === "light" ? "#d1d5db" : "#2E2E2E"
                          }`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: { xs: "20px", sm: "10px" },
                      }}
                    >
                      <Image
                        cdn={service.icon}
                        alt={`${service.title} Icon`}
                        style={{
                          width: "75%",
                          height: "75%",
                          objectFit: "contain",
                        }}
                      />
                    </Box>

                    {/* Title + Button */}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        height: "100%",
                        flexDirection: {
                          xs: "row",
                          sm: "column",
                        },
                        justifyContent: {
                          xs: "space-between",
                          sm: "center",
                        },
                        alignItems: {
                          xs: "center",
                          sm: "start",
                        },
                        gap: 1,
                        marginTop: { xs: "20px", sm: "10px" },
                      }}
                    >
                      <Typography
                        sx={{
                          fontWeight: { xs: 400, sm: 500 },
                          fontSize: { xs: "1.2rem", sm: "1.7rem" },
                          color: mode === "light" ? "#000" : "#fff",
                        }}
                      >
                        {service.title}
                      </Typography>

                      <Button
                        variant="contained"
                        sx={{
                          width: "fit-content",
                          fontSize: { xs: "0.85rem", sm: "1.0rem" },
                          padding: { xs: "6px 18px", sm: "6px 25px" },
                          textTransform: "none",
                          backgroundColor: "#007BFF",
                          borderRadius: "8px",
                          ":hover": {
                            backgroundColor: "#156edc",
                          },
                        }}
                        onClick={() => window.location.href = service.route}
                      >
                        Access
                      </Button>
                    </Box>
                  </Box>
                </CardContent>
              </Box>
            );
          })
        ) : (
          <Box
            width="100%"
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            height="300px"
            gridColumn="1 / -1"
            textAlign="center"
            sx={{ color: "#888" }}
          >
            <Typography variant="h6">No Unused Services Found</Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Unused;
